const userAgent = window.navigator.userAgent || window.navigator.vendor

export const isAndroid = /android/i.test(userAgent)
export const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream

export const isMobile = isAndroid || isIOS

export const demoOrContactHref = isMobile ? '/contact' : '/demo'

export const demoOrContactLabel = (siteWide) => isMobile ? siteWide.contact_button : siteWide.demo_signup_button
